import React from 'react';
import Pagination from 'react-bootstrap/Pagination';

function range(start, count) {
  return Array.apply(0, Array(count))
    .map((element, index) => index + start);
}

class TablePagination extends React.Component {
  constructor(props) {
    super(props);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    const page = e.target.tagName === 'SPAN'
      ? e.target.offsetParent.getAttribute('data-page')
      : e.target.getAttribute('data-page');
    this.props.changePage(page);
    e.preventDefault();
  }

  render() {
    const currentPage = this.props.currentPage;
    const lastPage = this.props.lastPage;
    const handleClick = this.handleClick;
    let pageRange;
    if (lastPage < 8) {
      console.log("last page less than 8");
      pageRange = range(1, lastPage);
      return (
        <Pagination>
          <Pagination.Prev
            disabled={currentPage === 1}
            onClick={handleClick}
            data-page={currentPage - 1}
          />
          {pageRange.map((value, index) => (
            <Pagination.Item
              key={index}
              onClick={handleClick}
              data-page={value}
              active={currentPage === value}
            >
              {value}
            </Pagination.Item>
          ))}
          <Pagination.Next
            onClick={handleClick}
            data-page={currentPage + 1}
          />
        </Pagination>
      )
    }
    if (currentPage <= 4)
      pageRange = range(1, 5);
    else if (currentPage > lastPage - 4)
      pageRange = range(lastPage - 4, 5);
    else
      pageRange = range(currentPage - 1, 3);
    return (
      <Pagination>
        <Pagination.Prev
          disabled={currentPage === 1}
          onClick={handleClick}
          data-page={currentPage - 1}
        />
        {currentPage > 4 && <>
          <Pagination.Item
            data-page="1"
            onClick={handleClick}
          >
            1
          </Pagination.Item>
          <Pagination.Ellipsis />
        </>}
        {pageRange.map((value, index) => (
          <Pagination.Item
            key={index}
            onClick={handleClick}
            data-page={value}
            active={currentPage === value}
          >
            {value}
          </Pagination.Item>
        ))}
          {currentPage <= lastPage - 4 && <>
          <Pagination.Ellipsis />
          <Pagination.Item
            onClick={handleClick}
            data-page={lastPage}
          >
            {lastPage}
          </Pagination.Item>
        </>}
        <Pagination.Next
          onClick={handleClick}
          data-page={currentPage + 1}
          disabled={currentPage === lastPage}
        />
      </Pagination>
    )
  }
}

export default TablePagination;
